/**
 * Form furniture shared by the two registry consoles.
 *
 * Split out rather than duplicated because the vendor and utility forms overlap
 * on most fields and diverge only in which ones exist — and a label that reads
 * differently on two pages describing the same on-chain argument is how an
 * operator ends up filling one of them in wrong.
 */
import type { ReactNode } from "react";

export function Field({
  id,
  label,
  hint,
  error,
  children,
}: {
  id: string;
  label: string;
  hint?: ReactNode;
  error?: string;
  children: ReactNode;
}) {
  return (
    <div className="registry-console__field">
      <label htmlFor={id}>{label}</label>
      {children}
      {hint ? <p className="registry-console__hint">{hint}</p> : null}
      {error ? (
        <p className="registry-console__error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

/** A computed value the operator is meant to read and compare, not edit. */
export function DerivedValue({ label, value }: { label: string; value: string }) {
  return (
    <p className="registry-console__hash">
      <span>{label}</span>
      <code>{value}</code>
    </p>
  );
}

export function StepHeading({ step, children }: { step: number; children: ReactNode }) {
  return (
    <span className="registry-step">
      <span aria-hidden>{step}</span>
      {children}
    </span>
  );
}
